import { AccessDataProtectionComponent } from '../component/AccessDataProtectionComponent';
import { AccessDataProtectionView } from '../view/AccessDataProtectionView';
import { templateAccessDataProtection } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetAccessDataProtectionResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class AccessDataProtectionController extends BaseWidgetController<GetAccessDataProtectionResponse> {
  public component: AccessDataProtectionComponent;
  public view: AccessDataProtectionView;
  public viewConstructor: typeof AccessDataProtectionView;

  constructor(component: AccessDataProtectionComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: AccessDataProtectionView,
      viewTemplate: templateAccessDataProtection,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getAccessDataProtection,
    });
  }
}
